import Box from '@mui/material/Box';
import React, {useEffect, useRef, useState} from 'react';
import {constance} from '../../common/constance/constance';
import Stack from '@mui/material/Stack';
import {config} from '../../common/config/config';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {styles} from '../../common/style';
import {Button, MenuItem, MenuList, Paper} from '@mui/material';
import {common} from '../../common/common';
import ImageUploading from 'react-images-uploading';
import {useNavigate} from 'react-router-dom';
import {User} from '../../interface/user.interface';
import {Evaluator} from "../../interface/evaluator.interface";
import WorkplaceComponent from "./WorkplaceComponent";
import {isMobile} from "react-device-detect";

interface State {
    userList: User[];
    userListOpen: boolean,
    evaluator: User,
    evaluatorName: string
}

function EvaluatorRegister() {
    const [evaluatorList, setEvaluatorList] = useState<Evaluator[]>([]);
    const [state, setState] = useState<State>({
        userList: [],
        userListOpen: false,
        evaluator: {_id: "", admin: false, departmentCode: "", departmentName: "", id: "", name: ""},
        evaluatorName: '',
    });

    const evaluatorNameRef: any = useRef();
    const evaluatorWorkplaceRef: any = useRef();

    useEffect(() => {
        getEvaluatorList();
        getUserList();
    }, []);

    function getEvaluatorList() {
        /* 사용자 리스트 가지고 오기 */
        axios.get(constance.api.getEvaluatorList).then((value) => {
            console.log(value.data.evaluatorList);
            setEvaluatorList(value.data.evaluatorList);
        }).catch(reason => {
        });
    }

    function getUserList() {
        /* 사용자 리스트 가지고 오기 */
        axios.get(constance.api.getUserList).then((value) => {
            if (value.data.data) {
                for (let user of value.data.data) {
                    user.name = user.name.trim();
                    user.id = user.id.trim();
                    user.departmentName = user.departmentName !== null ? user.departmentName.trim() : '';
                    user.departmentCode = user.departmentCode.trim();
                }
                setState({
                    ...state,
                    userList: value.data.data,
                });
            }
        }).catch(reason => {
            alert(reason);
        });
    }


    function handleSave() {
        let evaluatorWorkplace: string = evaluatorWorkplaceRef.current.value;

        axios.post(constance.api.saveEvaluator, {
            params: {
                userId: state.evaluator._id,
                workplace: evaluatorWorkplace,
            },
        }).then(value => {
            if (value.data.result) {
                common.alert('평가자 생성 완료', '', 'info');
            } else {
                common.alert('평가자 생성 실패', '이미 존재하는 평가자 입니다.', 'info');
            }
            evaluatorNameRef.current.value = '';
            getEvaluatorList();
        })
    }

    function handleDelete(_id: string) {
        let callback = (params: { _id: string }) => {
            return axios.post(constance.api.deleteEvaluator, {
                params: {
                    _id: params._id,
                },
            }).then(value => {
                if (value.data.result) {
                    common.alert('평가자 삭제 완료', '', 'info');
                } else {
                    common.alert('평가자 삭제 실패', '', 'info');
                }
                evaluatorNameRef.current.value = '';
                getEvaluatorList();
            })
        }
        common.confirm(
            `평가자를 삭제하시겠습니까?`,
            ``,
            'warning',
            callback,
            {_id: _id}
        );
    }


    const handleEvaluatorChange = (event: any) => {
        setState({
            ...state,
            evaluatorName: event.target.value
        });
    };

    function handleOpenList() {
        setState({
            ...state,
            userListOpen: true,
            evaluatorName: '',
        });
    }


    function handleChangeEvaluator(e: any, user: User) {
        setState({
            ...state,
            userListOpen: false,
            evaluator: user,
            evaluatorName: `${user.departmentName} ${user.name}`,
        });
    }

    let fontSize: any = isMobile ? "subtitle2" : "subtitle1";

    return (
        <>
            <Stack sx={{width: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Box id="box"
                     sx={{
                         display: 'flex',
                         pt: 3,
                         maxWidth: config.maxWidth,
                         width: 1,
                         justifyContent: 'center',
                         alignItems: 'flex-start'
                     }}>
                    <Stack sx={{width: 0.5, height: 1, mr: 3}}>
                        <Paper sx={{width: 1, p: 2}}>
                            <Stack>
                                <Box sx={{width: 1, display: 'flex', mb: 1, borderBottom: styles.border, pb: 1}}>
                                    <Typography align={"center"} sx={{width: 0.2}}>{'평가 사업장'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.3}}>{'부서'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.2}}>{'이름'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.2}}>{'생성일'}</Typography>
                                    <Typography align={"center"} sx={{width: 0.1}}>{''}</Typography>
                                </Box>
                                {
                                    evaluatorList.map((value, index) => {
                                        return (
                                            <Box key={index}
                                                 sx={{
                                                     width: 1,
                                                     display: 'flex',
                                                     alignItems: 'center',
                                                     pt: 0.5,
                                                     pb: 0.5,
                                                     borderBottom: styles.border
                                                 }}>
                                                <Typography align={"center"} sx={{
                                                    width: 0.2,
                                                    pl: 0.5,
                                                    pr: 0.5
                                                }}>{constance.workplaceNameMap[value.workplace]}</Typography>
                                                <Typography align={"center"} sx={{
                                                    width: 0.3,
                                                    pl: 0.5,
                                                    pr: 0.5
                                                }}>{value.user.departmentName}</Typography>
                                                <Typography align={"center"} sx={{
                                                    width: 0.2,
                                                    pl: 0.5,
                                                    pr: 0.5
                                                }}>{value.user.name}</Typography>
                                                <Typography align={"center"} sx={{
                                                    width: 0.2,
                                                    pl: 0.5,
                                                    pr: 0.5
                                                }}>{common.getTimeFormatYMD(value.createdAt)}</Typography>
                                                <Button sx={{width: 0.1}}
                                                        size={"small"}
                                                        color={"error"}
                                                        onClick={() => handleDelete(value._id)}
                                                        variant={"contained"}>
                                                    <Typography>삭제</Typography>
                                                </Button>
                                            </Box>
                                        )
                                    })
                                }
                            </Stack>
                        </Paper>
                    </Stack>
                    <Stack sx={{
                        width: 0.5,
                        maxWidth: config.maxWidth,
                        alignItems: 'center',
                    }}>
                        {/* 평가자명 */}
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            borderBottom: '0px',
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 150}}> {'평가 사업장'}</Typography>
                            </Box>
                            <Stack
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <WorkplaceComponent workplaceRef={evaluatorWorkplaceRef} useAllWorkplace={'Y'}/>
                            </Stack>
                        </Box>

                        {/* 평가자명 */}
                        <Box sx={{
                            display: 'flex',
                            border: styles.border,
                            width: 1,
                        }}>
                            <Box sx={{
                                display: 'flex',
                                backgroundColor: styles.backgroundColor.titleBox,
                                p: 1,
                                pl: 2,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography variant={'h6'} sx={{width: 150}}> {'평가자'}</Typography>
                            </Box>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    backgroundColor: styles.backgroundColor.contentBox,
                                    p: 1,
                                }}>
                                <TextField inputRef={evaluatorNameRef}
                                           defaultValue={''}
                                           type={'text'}
                                           value={state.evaluatorName}
                                           onClick={handleOpenList}
                                           onChange={(e) => handleEvaluatorChange(e)}
                                           label="" variant="outlined"
                                           sx={{
                                               width: 1,
                                               height: 1,
                                               backgroundColor: 'var(--scc-surface)',
                                               border: '0px',
                                               borderRadius: 1
                                           }}
                                />
                                <Paper sx={{
                                    width: 320,
                                    maxWidth: '100%',
                                    position: 'absolute',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 10,
                                    display: state.userListOpen ? 'flex' : 'none',
                                }}>
                                    <MenuList>
                                        {
                                            state.userList.map((user, index) => {
                                                if (common.isEmpty(user.departmentName)) return;
                                                if (user.name == '이남주' && user.departmentName == '디자인팀') return;
                                                if (state.evaluatorName !== '') {
                                                    if (user.name.indexOf(state.evaluatorName) == -1 &&
                                                        user.departmentName.indexOf(state.evaluatorName) == -1) {
                                                        return;
                                                    }
                                                }
                                                return (
                                                    <MenuItem value={user.id}
                                                              key={index}
                                                              onClick={(e) => handleChangeEvaluator(e, user)}>
                                                        <Typography variant={fontSize}>
                                                            {`${user.departmentName} ${user.name}`}
                                                        </Typography>
                                                    </MenuItem>
                                                );
                                            })
                                        }

                                    </MenuList>
                                </Paper>
                            </Box>
                        </Box>


                        <Box sx={{mt: 2}}>
                            <Button onClick={handleSave}
                                    variant={'contained'}>
                                <Typography> {'등록'}</Typography>
                            </Button>
                        </Box>
                    </Stack>
                </Box>
            </Stack>
        </>
    );
};

export default EvaluatorRegister;